module.exports = __webpack_public_path__ + "static/media/single-light.17c597ef.svg";